module.exports = __webpack_public_path__ + "img/voilesetvoiliers-header.c95ee6dc.jpg";